/**
 * @jsxRuntime classic
 * @jsx jsx
 */
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
import { css, jsx } from '@emotion/react';

/**
 * Conditional wrapper for the ValueContainer in Select. Provides a workaround
 * for issues using react-select on react-beautiful-dnd Draggable elements.
 * @returns
 */
var ValueContainerWrapper = function ValueContainerWrapper(_ref) {
  var children = _ref.children,
    isEnabled = _ref.isEnabled,
    onMouseDown = _ref.onMouseDown;
  return isEnabled ?
  // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
  jsx("div", {
    css: css({
      flexGrow: 1
    }),
    onMouseDown: onMouseDown
  }, children) : children;
};
export default ValueContainerWrapper;